module.exports = __webpack_public_path__ + "img/man-relax.1583738e.png";